// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2XFVN","sectionlist":"home_sectionlist__3oCwL","button":"home_button__3Hlzl","toparrow":"home_toparrow__3_I10"};